export default function () {

  return function nrg(val = '') {
    if (val > 0.0 && val <= 0.5) {
      return 'Muy reducido';
    } else if (val > 0.5 && val <= 1.0) {
      return 'Reducido';
    } else if (val > 1.0 && val <= 1.5) {
      return 'Elevado';
    } else if (val > 1.5 && val <= 2.0) {
      return 'Muy elevado';
    } else if (val > 2.0 && val <= 5.0) {
      return 'Grave';
    } else if (val > 5.0 && val <= 10.0) {
      return 'Muy grave';
    } else if (val > 10.0) {
      return 'Catastrófico';
    }
    return '--';
  };
}



// WEBPACK FOOTER //
// ./src/filters/nrg.js